/**
 * @file WmsPickingPage.tsx
 * @description «Задания на сборку»: очередь и журнал (phase19.14, экран A
 * шага 0 + журнал; phase19.23, A1; phase19.31 шаг О4 — макет (г)).
 *
 * Страница отвечает только за режим и маршруты: рабочий список кладовщика
 * живёт в `PickingQueuePanel`, закрытые задания — в `PickingHistoryPanel`.
 * Заголовок в верхней панели и вкладки «Очередь / Журнал» рисует панель —
 * у неё хук с данными, а значит и «Обновить».
 *
 * Страница лежит прямо на фоне, в стандартной колонке каркаса (SC55) — без
 * белой карточки-обёртки и своей ширины.
 *
 * Режим держим в URL (`?view=history`): «Назад» из карточки задания обязано
 * вернуть туда, откуда ушли, а не всегда в очередь.
 */

import { useParams, useSearchParams } from "react-router";

import { useAuth } from "../../../auth/hooks";
import { PickingHistoryPanel } from "../../../components/wms/picking/PickingHistoryPanel";
import { PickingQueuePanel } from "../../../components/wms/picking/PickingQueuePanel";
import { parseQueueTab } from "../../../components/wms/picking/usePickingQueue";
import { parsePickingView, type PickingView } from "../../../components/wms/picking/picking-view";

export function WmsPickingPage() {
  const { slug } = useParams<{ slug: string }>();
  const { me } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const basePath = `/shop/${slug}/wms`;
  // Доска заказов (router.tsx: orders/board) — действие пустых состояний.
  const ordersBoardPath = `/shop/${slug}/orders/board`;
  const userId = me?.user.id ?? null;
  const view = parsePickingView(searchParams.get("view"));

  /** Очередь — режим по умолчанию, её в URL не пишем (короткая ссылка). */
  function changeView(next: PickingView) {
    const params = new URLSearchParams(searchParams);
    if (next === "queue") params.delete("view");
    else params.set("view", next);
    setSearchParams(params, { replace: true });
  }

  return (
    <div className="flex flex-col gap-4">
      {view === "history" ? (
        <PickingHistoryPanel
          view={view}
          onViewChange={changeView}
          basePath={basePath}
          ordersBoardPath={ordersBoardPath}
          currentUserId={userId}
        />
      ) : (
        <PickingQueuePanel
          view={view}
          onViewChange={changeView}
          basePath={basePath}
          ordersBoardPath={ordersBoardPath}
          currentUserId={userId}
          // `?tab=shortage&wh=…` — вход с плитки «Недостача» обзора склада.
          initialTab={parseQueueTab(searchParams.get("tab"))}
          initialWarehouseId={searchParams.get("wh") ?? ""}
        />
      )}
    </div>
  );
}
